/**************************************************
 * Nombre:       Formulario_Escuela_Indicadores
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import Tarjetas_Beneficios from "../../Tarjeta/Tarjetas_Beneficios";
import Formulario_Escuela_Indicadores_Indicador from "./Formulario_Escuela_Indicadores_Indicador";
import Tarjetas_Indicador from "../../Tarjeta/Tarjetas_Indicador";

const Formulario_Escuela_Indicadores = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        nombre: 'Ingresar Indicador',
        dato: 'indicadores',
        Tarjeta: Tarjetas_Indicador,
        Formulario: Formulario_Escuela_Indicadores_Indicador
    });


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Escuela_Indicadores